/* KUTEE' transparent header: solid once the page is scrolled.
   Loaded only when the header renders with .ku-header--transparent.
   Queries the wrapper fresh on each tick so it survives Theme Editor
   section re-renders (no stale node references). */
(() => {
  const apply = () => {
    const wrapper = document.querySelector('.ku-header--transparent');
    if (!wrapper) return;
    /* Solid while the drawer menu is open — a transparent strip over the
       cream drawer shows the page image through it and looks broken. */
    const drawerOpen = !!wrapper.querySelector('details.menu-drawer-container[open]');
    wrapper.classList.toggle('ku-header--solid', drawerOpen || window.scrollY > 24);
    document.documentElement.style.setProperty('--header-height', `${wrapper.offsetHeight}px`);
  };

  window.addEventListener('scroll', apply, { passive: true });
  window.addEventListener('resize', apply);
  document.addEventListener('toggle', apply, true);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:section:unload', apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();

/* Nav dropdown hover/click-through wiring lives in ku-menu-hover.js
   (loaded on every page) — this file is gated to transparent-header
   templates and must not own site-wide nav behavior. */
